import { MatomoProvider } from '@datapunt/matomo-tracker-react';
import {
  BrowserRouter,
  MemoryRouter,
} from 'react-router-dom';
import React from 'react';
import PropTypes from 'prop-types';

import { useCookies } from './hooks/CookieProvider';
import matomo from './modules/matomo';
import AppRouteElements from './routes';

const AppRouteContainer = ({ url = null }) => {
  const Router = url ? MemoryRouter : BrowserRouter;
  return (
    <Router {...(url ? { initialEntries: [url] } : {})}>
      <AppRouteElements />
    </Router>
  );
};

AppRouteContainer.propTypes = {
  url: PropTypes.string,
};

const AppRoutes = ({ url = null }) => {
  const cookieConsent = useCookies();
  const { isAccepted } = cookieConsent;
  const statisticsAccepted = isAccepted('statistics');
  const matomoInstance = React.useMemo(
    () => statisticsAccepted ? matomo() : null,
    [statisticsAccepted],
  );

  return statisticsAccepted ? (
    <MatomoProvider value={matomoInstance}>
      <AppRouteContainer url={url} />
    </MatomoProvider>
  ) : <AppRouteContainer url={url} />;
}

AppRoutes.propTypes = {
  url: PropTypes.string,
};

export default AppRoutes;
